import { render, staticRenderFns } from "./ThreeDotMenuItem.vue?vue&type=template&id=da9a1740&scoped=true&"
import script from "./ThreeDotMenuItem.vue?vue&type=script&lang=js&"
export * from "./ThreeDotMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./ThreeDotMenuItem.vue?vue&type=style&index=0&id=da9a1740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da9a1740",
  null
  
)

export default component.exports